export const IN_BROWSER = typeof window !== 'undefined' && typeof document !== 'undefined';
//# sourceMappingURL=index.mjs.map